exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#areas[data-v-1d3c56c6]{position:relative}.err-tips[data-v-1d3c56c6]{color:#f56c6c;font-size:12px;line-height:1;padding-top:4px;position:absolute;top:100%;left:0}.is-error-tips input[data-v-1d3c56c6]{border-color:#f56c6c!important}.select[data-v-1d3c56c6]{width:106px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d3c56c6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/area/Areas.vue
// module id = 9
// module chunks = 0